export default __webpack_public_path__ + "static/media/analytics-page-dark.8b9ffed6.png";